/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { selectCurrentUserApiToken } from '../slices/currentUser/currentUserSlice';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { useParams } from 'react-router-dom';
import loadInvite from '../functions/loadInviteAPI';
import acceptInvite from '../functions/acceptInviteAPI';

const acceptInviteFromPage = async (apiToken, inviteCode, setInvitePageState) => {

    let response = await acceptInvite(apiToken, inviteCode);
    if (response?.success) {
        setInvitePageState(prevState => { return { ...prevState, 'acceptedInvite': true }; });
    }
}

const loadInviteToPage = async (apiToken, inviteCode, setInvitePageState) => {

    let response = await loadInvite(apiToken, inviteCode);
    if (response?.success) {
        setInvitePageState({
            'loaded': true, 'loading': false,
            'inviter': response.inviter, 'resourceId': response.resourceId,
            'resourceTitle': response.resourceTitle, 'alreadyJoined': response.alreadyjoined
        });
    } else {
        setInvitePageState({ 'loading': false });
    }
}

// eslint-disable-next-line no-empty-pattern
const InvitedToResourcePage = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const { inviteCode } = useParams();

    const [invitePageState, setInvitePageState] = useState({ 'loading': true, 'loaded': false });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Resource Invite"));
    }, []);

    useEffect(() => {
        if (apiToken && inviteCode) {
            loadInviteToPage(apiToken, inviteCode, setInvitePageState);
        }
    }, [apiToken]);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {invitePageState.loading &&
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Loading</Loader>
                </Dimmer>
            }
            {apiToken ?
                <>
                    {invitePageState.loaded ?
                        <>
                            {invitePageState.acceptedInvite ?
                                <>
                                    <h2>You are now an editor for <a href={"/" + invitePageState.resourceId} target="_blank"
                                        rel="noopener noreferrer">{invitePageState.resourceTitle} ({invitePageState.resourceId})</a>
                                    </h2>
                                </>
                                :
                                <>

                                    <h2 style={{ textAlign: "center", color: "#AC3B61" }}>
                                        You've been invited by {invitePageState.inviter} to become an editor for resource: {invitePageState.resourceTitle} (<a href={"/" + invitePageState.resourceId}
                                            target="_blank" rel="noopener noreferrer">{invitePageState.resourceId}</a>)
                                    </h2>
                                    <br /><br />
                                    {invitePageState.alreadyJoined ?
                                        <h2>You are already an editor for this resource.</h2>
                                        :
                                        <Button className="formButton positive"
                                            content="Join as an Editor for the Resource" compact
                                            onClick={() => {
                                                /* TODO - CREATE SERVER SIDE FUNCTION TO BE ADDED TO PERMISSION GROUP, pass the invite code to the function*/
                                                acceptInviteFromPage(apiToken, inviteCode, setInvitePageState);
                                            }} />
                                    }
                                </>
                            }
                        </>
                        :
                        <>{!invitePageState.loading &&
                            <h2>No invite has been found with that code. Perhaps the invite link was revoked.</h2>}</>
                    }
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>
};

export default InvitedToResourcePage;